import {ModalComponentsMap} from 'components/InputMenu/helpers';
import {useInputMenuContext} from 'context/InputMenu';
import {useModalWindow} from 'hooks/useModalWindow';
import * as I from 'interfaces';
import {type FC} from 'react';

function ModalMenu() {
  const inputMenuContext = useInputMenuContext();
  const inputMenuState = inputMenuContext?.state;
  const inputMenuDispatch = inputMenuContext?.dispatch;
  const {closeModalWindow} = useModalWindow();

  // Supports backward compatibility with legacy modal API
  let Component: FC<I.ModalDialogProps<any, any>>;
  let closeDrawer: () => void;
  let onBeforeClose: ((entity: any) => void) | undefined;
  let formDataPayload: any;

  if (inputMenuState?.form && inputMenuState.method && ModalComponentsMap.has(inputMenuState.form)) {
    Component = ModalComponentsMap.get(inputMenuState.form) as FC<I.ModalDialogProps<any, any>>;
    closeDrawer = () => inputMenuDispatch && inputMenuDispatch({type: I.inputMenuActionType.closeMenu});
    onBeforeClose = inputMenuState.onClose;
    formDataPayload = inputMenuState.formData;
  } else if (inputMenuState?.modalWindow) {
    Component = inputMenuState.modalWindow.component;
    closeDrawer = closeModalWindow;
    onBeforeClose = inputMenuState.modalWindow?.onClose;
    formDataPayload = inputMenuState.modalWindow?.payload;
  } else {
    return null;
  }

  const modalProps: I.ModalDialogProps<any, any> = {
    dialogProps: {
      onClose: closeDrawer,
      open: true,
      maxWidth: false,
    },
    dialogTitleProps: {
      sx: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
      },
    },
    modalComponentProps: {
      onBeforeClose,
      formDataPayload: formDataPayload ?? {},
    },
  };

  return <Component {...modalProps}></Component>;
}

export default ModalMenu;
